// src/types/notifications.ts
export enum NotificationType {
  Assignment = 'assignment',
  TaskCompleted = 'task_completed',
  DeadlineAlert = 'deadline_alert',
  StatusUpdate = 'status_update',
  System = 'system',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success'
}

export enum NotificationPriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Critical = 'critical'
}

export interface Notification {
  id: string;
  type: NotificationType;
  priority: NotificationPriority;
  title: string;
  message: string;
  isRead: boolean;
  createdAt: Date;
  readAt?: Date;
  actionUrl?: string;
  actionText?: string;
  metadata?: {
    requestId?: string;
    taskId?: string;
    userId?: string;
    projectName?: string;
    [key: string]: any;
  };
}

export interface NotificationSettings {
  enableToasts: boolean;
  enableSounds: boolean;
  autoHideDelay: number; // milliseconds
  maxToasts: number;
  enabledTypes: NotificationType[];
}

export interface NotificationFilter {
  type?: NotificationType;
  priority?: NotificationPriority;
  isRead?: boolean;
  dateFrom?: Date;
  dateTo?: Date;
  searchText?: string;
}

export interface NotificationStats {
  total: number;
  unread: number;
  byType: Record<NotificationType, number>;
  byPriority: Record<NotificationPriority, number>;
}